import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { PatientStatus } from '../components/widgets/PatientStatus';
import { DrillDownContext } from '../components/widgets/PatientStatus/types';

export default function Dashboard() {
  const navigate = useNavigate();

  const handleDrillDown = (ctx: DrillDownContext) => {
    navigate(`/dashboard/drill/${ctx.stage}/${ctx.side}`);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="Patient" />
        <main className="flex-1 overflow-y-auto p-6 space-y-6">
          <PatientStatus onDrillDown={handleDrillDown} />
        </main>
      </div>
    </div>
  );
}
